import { render, staticRenderFns } from "./UiInfo.vue?vue&type=template&id=43c0a2c6&lang=pug&"
import script from "./UiInfo.vue?vue&type=script&lang=js&"
export * from "./UiInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports